module.exports = __webpack_public_path__ + "static/media/endoraLogo.8c42bd4b.png";